import React from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../Components/PrimaryButton";

function Error() {
    const navigate = useNavigate();

    const onHomeClick = () => {
        navigate("/");
    };

    return (
        <div className='error'>
            <div className='error-page-center'>
                <div className='description-section'>
                    <h2 className='title'>Page not found</h2>
                    <p className='text'>
                    Sorry, we can't find the page you're looking for.
                    </p>
                    
                    <div className="errorPagePrimaryButton">
                        <PrimaryButton
                            label={"Home"}
                            variant={"primary-btn"}
                            onClick={onHomeClick}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Error;
